import Vue from 'vue';
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  setInteractionMode,
} from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
import { required, email } from 'vee-validate/dist/rules';

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

localize('es', es);

extend('required', required);
extend('email', email);
extend('url', {
  validate: (str) => {
    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(str);
  },
  message: 'No es una URL válida',
});
extend('no-special-characters', {
  validate: (str) => {
    var pattern = new RegExp('^[a-zA-Z]');
    return !!pattern.test(str);
  },
  message: 'No se permiten caracteres especiales.',
});
extend('greaterThanZero', (value) => {
  if (!isNaN(value) && value > 0) return true;
  return 'Favor de añadir un valor mayor de cero';
});
setInteractionMode('eager');

//time2 is greater than time1
extend('timeGreaterThan', {
  params: ['target'],
  validate(value, { target }) {
    return value > target;
  },
  message: 'La hora de inicio debe ser menor que la hora de fin',
});
extend('numberNa', (value) => {
  if (/^(?:\d+|NA|N\/A)$/i.test(value)) {
    return true;
  }

  return 'Los valores permitidos son: Números, NA, N/A';
});

extend('completePhone', (value) => {
  if (value != null) {
    let phoneNumber = value
      .toString()
      .replace(/\D/g, '')
      .toString();
    if (phoneNumber.length < 10 && phoneNumber.length != 0) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
});
